import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
              {t('categories.title')}
            </h2>
            <p className="text-base text-foreground-600 max-w-2xl mx-auto">
              {t('categories.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {categories.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 overflow-hidden transition-all cursor-pointer"
              >
                <div className="w-full aspect-square overflow-hidden bg-secondary-50">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <div className="flex items-center justify-between p-3 md:p-3.5">
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors truncate">
                    {cat.name}
                  </span>
                  <span className="w-5 h-5 flex items-center justify-center shrink-0 ml-1">
                    <i className="ri-arrow-right-up-line text-xs text-foreground-300 group-hover:text-primary-400 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}